/* GetStream Dark Theme Override for CF Store */
/* Matches: #0a0a0c bg, #111114 surface, #1a1a1e elevated, #FF6B35 accent */

:root {
  /* Stream Chat CSS variable overrides */
  --str-chat__primary-color: #FF6B35;
  --str-chat__active-primary-color: #e85a24;
  --str-chat__surface-color: #111114;
  --str-chat__secondary-surface-color: #1a1a1e;
  --str-chat__primary-surface-color: #0a0a0c;
  --str-chat__primary-surface-color-low-emphasis: #111114;
  --str-chat__secondary-background-color: #111114;
  --str-chat__background-color: #0a0a0c;
  --str-chat__border-color: rgba(255, 255, 255, 0.08);
  --str-chat__disabled-color: #64748b;
  --str-chat__cta-color: #FF6B35;
  --str-chat__text-color: #ffffff;
  --str-chat__text-low-emphasis-color: #94a3b8;
  --str-chat__text-high-emphasis-color: #ffffff;
  --str-chat__text-medium-emphasis-color: #94a3b8;
  --str-chat__overlay-color: rgba(0, 0, 0, 0.7);
  --str-chat__danger-color: #ef4444;
  --str-chat__info-color: #3b82f6;
  --str-chat__success-color: #22c55e;
  --str-chat__warning-color: #f59e0b;
  --str-chat__font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

/* Main container */
.str-chat {
  background-color: #0a0a0c;
  color: #ffffff;
}

/* Channel list */
.str-chat__channel-list {
  background: #0a0a0c;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.str-chat__channel-list-messenger {
  background: #0a0a0c;
}

.str-chat__channel-preview-messenger--active {
  background: #1a1a1e;
}

.str-chat__channel-preview-messenger:hover {
  background: #111114;
}

.str-chat__channel-preview-messenger--last-message {
  color: #94a3b8;
}

.str-chat__channel-preview-messenger--name {
  color: #ffffff;
}

/* Channel header */
.str-chat__header-livestream {
  background: #111114;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

/* Message list */
.str-chat__list {
  background: #0a0a0c;
}

.str-chat__message-simple {
  color: #ffffff;
}

.str-chat__message-text-inner {
  background: #1a1a1e;
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

/* Own messages use accent tint */
.str-chat__message--me .str-chat__message-text-inner {
  background: rgba(255, 107, 53, 0.15);
  border-color: rgba(255, 107, 53, 0.2);
  color: #ffffff;
}

.str-chat__message-sender-name {
  color: #94a3b8;
}

.str-chat__message-simple-timestamp {
  color: #64748b;
}

/* Message input */
.str-chat__message-input {
  background: #111114;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.str-chat__textarea textarea {
  background: #1a1a1e !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  color: #ffffff !important;
  border-radius: 20px;
}

.str-chat__textarea textarea::placeholder {
  color: #64748b !important;
}

.str-chat__textarea textarea:focus {
  border-color: #FF6B35 !important;
  box-shadow: 0 0 0 1px rgba(255, 107, 53, 0.3) !important;
}

/* Send button */
.str-chat__send-button {
  background: #FF6B35;
  border-radius: 50%;
}

.str-chat__send-button:hover {
  background: #e85a24;
}

/* Thread */
.str-chat__thread {
  background: #0a0a0c;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
}

.str-chat__thread-header {
  background: #111114;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

/* Reactions */
.str-chat__reaction-list {
  background: #1a1a1e;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Emoji picker / action buttons */
.str-chat__message-actions-box {
  background: #1a1a1e;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

/* Loading indicators */
.str-chat__loading-indicator {
  color: #FF6B35;
}

/* Scrollbar styling */
.str-chat__list::-webkit-scrollbar {
  width: 6px;
}

.str-chat__list::-webkit-scrollbar-track {
  background: #0a0a0c;
}

.str-chat__list::-webkit-scrollbar-thumb {
  background: #1a1a1e;
  border-radius: 3px;
}

.str-chat__list::-webkit-scrollbar-thumb:hover {
  background: #2a2a2e;
}

/* Channel search */
.str-chat__channel-search {
  background: #0a0a0c;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.str-chat__channel-search input {
  background: #1a1a1e;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.str-chat__channel-search input::placeholder {
  color: #64748b;
}

/* Date separators */
.str-chat__date-separator-date {
  color: #64748b;
}

.str-chat__date-separator-line {
  background: rgba(255, 255, 255, 0.08);
}

/* Unread badge */
.str-chat__unread-badge {
  background: #FF6B35;
  color: #ffffff;
}

/* Avatar */
.str-chat__avatar {
  border: 2px solid rgba(255, 255, 255, 0.08);
}

/* Attachment previews */
.str-chat__message-attachment {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
}

/* Loading channels */
.str-chat__loading-channels {
  background: #0a0a0c;
}

/* Typing indicator */
.str-chat__typing-indicator {
  color: #94a3b8;
}

/* System messages */
.str-chat__message--system {
  color: #64748b;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .str-chat__channel-list {
    width: 100% !important;
  }
}

/* ===== Custom Feed & Notification Component Styles ===== */
/* These apply to CF Store's custom ActivityFeed, NotificationFeed, ForYouFeed components */

.cf-activity-feed,
.cf-notification-feed,
.cf-for-you-feed {
  color: #ffffff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.cf-feed-empty,
.cf-notif-empty {
  text-align: center;
  padding: 32px 16px;
  color: #64748b;
}

.cf-feed-empty__hint {
  font-size: 0.85rem;
  color: #475569;
  margin-top: 4px;
}

.cf-feed-error,
.cf-notif-error {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 0.9rem;
}

.cf-feed-loading,
.cf-notif-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  color: #64748b;
}

.cf-feed-loading__spinner,
.cf-notif-loading__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.06);
  border-top-color: #FF6B35;
  border-radius: 50%;
  animation: cf-spin 0.8s linear infinite;
  margin-bottom: 12px;
}

@keyframes cf-spin {
  to { transform: rotate(360deg); }
}

/* Activity items */
.cf-activity-item {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.cf-activity-item:last-child {
  border-bottom: none;
}

.cf-activity-item__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 107, 53, 0.15);
  color: #FF6B35;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.cf-activity-item__body {
  flex: 1;
  min-width: 0;
}

.cf-activity-item__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 4px;
}

.cf-activity-item__actor { color: #ffffff; font-size: 0.9rem; }
.cf-activity-item__verb { color: #94a3b8; font-size: 0.85rem; }
.cf-activity-item__time { color: #475569; font-size: 0.8rem; margin-left: auto; }

.cf-activity-item__content {
  color: #94a3b8;
  font-size: 0.85rem;
  line-height: 1.5;
}

.cf-activity-item__reactions {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  font-size: 0.85rem;
  color: #64748b;
}

.cf-feed-load-more {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  background: rgba(255, 107, 53, 0.1);
  color: #FF6B35;
  border: 1px solid rgba(255, 107, 53, 0.2);
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.cf-feed-load-more:hover {
  background: rgba(255, 107, 53, 0.2);
}

/* Notification items */
.cf-notif-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.cf-notif-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
}

.cf-notif-badge {
  background: #FF6B35;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 10px;
}

.cf-notif-mark-all {
  margin-left: auto;
  background: none;
  border: none;
  color: #FF6B35;
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0;
}

.cf-notif-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: background 0.15s;
}

.cf-notif-item:hover { background: rgba(255, 255, 255, 0.02); }
.cf-notif-item:last-child { border-bottom: none; }
.cf-notif-item--unread { background: rgba(255, 107, 53, 0.04); }

.cf-notif-item__icon { font-size: 1.1rem; flex-shrink: 0; width: 28px; text-align: center; }
.cf-notif-item__body { flex: 1; min-width: 0; }
.cf-notif-item__text { font-size: 0.9rem; color: #e2e8f0; line-height: 1.4; }
.cf-notif-item__time { font-size: 0.8rem; color: #475569; margin-top: 2px; }

.cf-notif-item__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #FF6B35;
  flex-shrink: 0;
  margin-top: 6px;
}

/* Reaction bar */
.cf-reaction-bar {
  display: flex;
  gap: 6px;
  align-items: center;
}

.cf-reaction-bar__btn {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 0.85rem;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.cf-reaction-bar__btn:hover {
  background: rgba(255, 107, 53, 0.1);
  border-color: rgba(255, 107, 53, 0.2);
  color: #FF6B35;
}

.cf-reaction-bar__btn--active {
  background: rgba(255, 107, 53, 0.15);
  border-color: rgba(255, 107, 53, 0.3);
  color: #FF6B35;
}

/* Poll widget */
.cf-poll {
  background: #111114;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 16px;
}

.cf-poll__question {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 12px;
}

.cf-poll__option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  color: #e2e8f0;
  font-size: 0.9rem;
}

.cf-poll__option:hover {
  background: rgba(255, 107, 53, 0.08);
  border-color: rgba(255, 107, 53, 0.2);
}

.cf-poll__option--voted {
  background: rgba(255, 107, 53, 0.12);
  border-color: rgba(255, 107, 53, 0.3);
}

.cf-poll__bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 2px;
  flex: 1;
  overflow: hidden;
}

.cf-poll__bar-fill {
  height: 100%;
  background: #FF6B35;
  border-radius: 2px;
  transition: width 0.3s;
}

.cf-poll__votes {
  font-size: 0.8rem;
  color: #64748b;
  margin-top: 8px;
}
